import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  Suspense,
} from "react";
import { Outlet } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import { useMainState } from "contexts/MainStateContext";
import ModalManager from "components/Modal/ModalManager";

import ClockDisplay from "../chronos/ClockDisplay";
import { getCurrentTime } from "../chronos/timeUtils";

export default function ChronosLayout() {
  const { user } = useUser();
  const { mainState, setMainState } = useMainState();
  const [time, setTime] = useState(getCurrentTime());

  // Actualizar hora cada segundo
  useEffect(() => {
    const id = setInterval(() => setTime(getCurrentTime()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
  <div className="flex flex-col h-screen overflow-hidden ctpanel p-0">

  {/* HEADER */}
  <div className="flex flex-col sm:flex-row items-center sm:justify-between 
                  border-b py-2 cttoolbox flex-none">
    
    <div className="text-center font-bold 
                    text-[5vw] sm:text-[4vw] md:text-[3vw] lg:text-[2.5vw] 
                    leading-tight truncate">
      {user.operari || "Operario no identificado"}
    </div>

    <div className="mt-2 sm:mt-0 sm:flex-none sm:self-center">
      <ClockDisplay time={time} size="medium" />
    </div>
  </div>

  {/* MAIN */}
  <main className="flex-1 min-h-0 p-0 overflow-hidden relative">
    <Suspense fallback={<div>Cargando...</div>}>

      {/* Contenedor interno que NO crece y NO tiene scroll */}
      <div className="h-full w-full overflow-hidden relative">
        <Outlet />
      </div>

    </Suspense>
  </main>

  {/* FOOTER */}
  <footer className="bg-white border-t border-gray-200 py-3 px-6 flex-none">
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-600">
        © 1985 - {new Date().getFullYear()} Toni Raventós - v1.0.0
      </span>
      <span className="text-sm text-gray-600">
        Usuario: {user?.name} | Empresa: {user?.empresa}
      </span>
    </div>
  </footer>

  <ModalManager />
</div>

  );
}
